"use client";
// Imports
import { Container, RowCard, ComponentWrapper } from "@/components";
import { getFilteredEvents } from "@/lib/helpers";
import { useKindeSession } from "@/components/KindeWrapper";
import useStore from "@/lib/state";

// Showbags Grid
export function FilteredEventsGrid({
  type,
  events,
  sortOrder,
  sortType,
  eventTypes,
  eventLocations,
  eventCategories,
  collectionHandle,
  showDates,
  mapIsActive,
}) {
  // Refine Results
  const refinedResults = getFilteredEvents(
    events,
    sortOrder,
    sortType,
    eventTypes,
    eventCategories,
    eventLocations
  );

  const { selectedDay } = useStore();
  const { user } = useKindeSession();
  const userId = user?.id || null;

  // Competition judging (and filtered events): red gum instead of saddle orange
  const redGumThemeStyle =
    collectionHandle === "events"
      ? {
          "--button-background": "137 33 2",
          "--button-hover-background": "137 33 2",
          "--button-foreground": "255 255 255",
        }
      : undefined;

  // Render
  return (
    <ComponentWrapper type={type}>
      <Container>
        <div className="grid gap-4 w-full" style={redGumThemeStyle}>
          {refinedResults?.length > 0
            ? refinedResults?.map((page, index) => (
                <RowCard
                  userId={userId}
                  mapIsActive={mapIsActive}
                  showDates={showDates}
                  collectionHandle={collectionHandle}
                  key={index}
                  index={index}
                  data={page}
                  title={page.title}
                  selectedDay={selectedDay}
                  image={page.image}
                  url={`${collectionHandle}/${page?.slug}`}
                  price={page?.showbag_price}
                />
              ))
            : null}
        </div>
      </Container>
    </ComponentWrapper>
  );
}
